import CaptainAssistantAPI from 'dashboard/api/captain/assistant';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import { createStore } from '../storeFactory';
import { createLatestListRequest } from './latestListRequest';

export default createStore({
  name: 'CaptainAssistant',
  API: CaptainAssistantAPI,
  actions: mutations => {
    const latestListRequest = createLatestListRequest(
      CaptainAssistantAPI,
      mutations
    );

    const updateLifecycle = async ({ commit }, action) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await action();
        commit(mutations.UPSERT, response.data);
        return response.data;
      } catch (error) {
        if (error?.response?.data?.error === 'publication_preflight_failed') {
          throw error;
        }
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    };

    return {
      get: latestListRequest.get,
      publish(context, payload) {
        return updateLifecycle(context, () =>
          CaptainAssistantAPI.publish(payload)
        );
      },
      unpublish(context, payload) {
        return updateLifecycle(context, () =>
          CaptainAssistantAPI.unpublish(payload)
        );
      },
    };
  },
});
